import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { getTraining, updateTraining } from '../services/trainingsService';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../../components/Dialog';
import TrainingForm from './TrainingForm';
import { Stack, CircularProgress, Button, Grid } from '@mui/material';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function EditTrainingDialog({ id, onClose, ...dialogProps }) {
  const [data, setData] = useState({ isFetching: true });
  const [editOn, setEditOn] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleTrainingUpdate = async (values, actions) => {
    try {
      values.id = id;
      await updateTraining(values);
      enqueueSnackbar(<FormattedMessage id='training.update.msg.success' defaultMessage='Training successfully updated' />, {
        variant: 'success',
      });
      onClose(true);
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id='training.update.msg.error' defaultMessage='Training update failed' />, {
        variant: 'error',
      });
      actions.setSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const training = await getTraining(id);
        enqueueSnackbar(<FormattedMessage id='training.get.msg.success' defaultMessage='Training successfully fetched' />, {
          variant: 'success',
        });
        setData({ isFetching: false, training });
      } catch (error) {
        enqueueSnackbar(<FormattedMessage id='training.get.msg.error' defaultMessage='Training fetch failed' />, {
          variant: 'error',
        });
        setData({ isFetching: false });
      }
    };

    fetchData();
  }, []);

  const handleCancel = () => {
    setEditOn(false);
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      {...dialogProps}
      onClose={handleClose}
      title={<FormattedMessage id='training.update.title' defaultMessage='Training' />}
    >
      {
        data.isFetching ?
          <Stack alignItems="center">
            <CircularProgress />
          </Stack> :
          <>
            {
              !editOn &&
              <Grid container justifyContent="flex-end" paddingBottom={2}>
                <Button
                  variant="contained"
                  onClick={() => setEditOn(true)}
                  startIcon={<Iconify icon="heroicons-solid:pencil"
                  />}
                >
                  <FormattedMessage id='training.button.edit' defaultMessage='Edit Training' />
                </Button>
              </Grid>
            }
            <TrainingForm
              training={data.training}
              onSubmit={handleTrainingUpdate}
              editOn={editOn}
              onCancel={handleCancel}
            />
          </>

      }
    </Dialog>
  );
}

EditTrainingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};
